// Landmarks for already-running legacy expeditions only. New exploration
// reveals the ordinary world, without premarked quest destinations.
import { DoubleSide, Mesh, MeshLambertMaterial, type Scene } from 'three'
import { type ExpeditionKind } from '../../shared/realm'
import { hexToPixel } from '../../shared/hex'
import { HEX_SIZE, type GameState } from '../state'
import { tileHeight } from './terrainMesh'
import { MeshBuilder } from './models3d/mesh'
import { fogOf, fogGround } from '../render/fog'

export class Adventures3d {
  private models=new Map<ExpeditionKind,Mesh>()
  constructor(scene:Scene){
    const material=new MeshLambertMaterial({vertexColors:true,flatShading:true,side:DoubleSide})
    for(const kind of ['forage','ruins','bandits'] as ExpeditionKind[]){
      const b=new MeshBuilder()
      if(kind==='forage'){
        b.cyl(0,0,0,16,3,8,0x527957)
        for(let i=0;i<5;i++){const a=i*Math.PI*2/5,x=Math.cos(a)*11,z=Math.sin(a)*11;b.cyl(x,3,z,1,9,5,0x466949);b.gem(x,14,z,8,9,8,0xc1f7b3)}
        b.gem(0,13,0,10,22,10,0xa6f0ca)
      }else if(kind==='ruins'){
        b.cyl(0,0,0,18,4,6,0x758384)
        b.box(-11,17,0,8,28,9,0x819a9c);b.box(11,17,0,8,28,9,0x819a9c)
        b.box(0,34,0,30,7,10,0xa0b4af);b.gem(0,16,0,8,16,8,0x8fdff0)
        b.box(-17,5,11,8,7,7,0x657572,.4)
      }else{
        b.box(0,6,0,24,12,15,0x785039);b.box(0,13,0,25,4,16,0xbd914e)
        b.box(0,8,8,4,5,2,0xf5d58a);b.cyl(-16,0,-8,1,36,5,0x674932)
        b.tri(-15,34,-8,2,28,-8,-15,23,-8,0xc46c55)
        b.gem(0,22,0,5,8,5,0xffdb86)
      }
      const mesh=new Mesh(b.geometry(),material);mesh.castShadow=true;mesh.visible=false;scene.add(mesh);this.models.set(kind,mesh)
    }
  }
  sync(st:GameState):void {
    const p=st.self?.realm,fog=fogOf(st)
    for(const [kind,mesh] of this.models){
      const site=p?.expedition?.kind===kind?p.expedition:undefined
      mesh.visible=!!site&&!st.observer&&!st.self?.ruined&&fogGround(fog,site.q,site.r)
      if(site){const pos=hexToPixel(site.q,site.r,HEX_SIZE);mesh.position.set(pos.x,tileHeight(st,site.q,site.r)+1,pos.y)}
    }
  }
}
